module.exports = __webpack_public_path__ + "img/fc53a11.jpg";